import React, { useState, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import { FiLogIn } from 'react-icons/fi';

import giveahandLogo from '~/assets/logo.png';
import { ReactComponent as GiveahandImg } from '~/assets/background.svg';

import colors from '~/styles/colors';

import {
  Container,
  FormWrapper,
  InputWrapper,
  Button,
  RegisterLink,
} from './styles';

import history from '~/services/history';
import api from '~/services/api';

export default function Login() {
  const formRef = useRef(null);

  const [id, setId] = useState('');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Give A Hand | Login';
  });

  async function handleSession(data, { reset }) {
    try {
      setLoading(true);

      const schema = Yup.object().shape({
        id: Yup.string().required('A sua ID é obrigatória.'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      formRef.current.setErrors({});

      const response = await api.post('/sessions', { id });

      localStorage.setItem('respId', id);
      localStorage.setItem('respName', response.data.name);

      toast.success(
        'Olá, seja bem-vindo(a). Cadastre as informações de quem está precisando de uma "mãozinha".'
      );

      reset();

      history.push('/profile');
    } catch (err) {
      setLoading(false);

      if (err instanceof Yup.ValidationError) {
        // console.log(err);

        const errorMessages = {};

        err.inner.forEach(error => {
          errorMessages[error.path] = error.message;
        });

        formRef.current.setErrors(errorMessages);
      }

      if (id) {
        toast.error('Falha no login. Verifique sua ID. :(');
      }
    }
  }

  return (
    <Container>
      <FormWrapper>
        <img src={giveahandLogo} alt="Give A Hand" />
        <p>
          Entre na plataforma e de uma <strong>mãozinha </strong> para quem está
          precisando de uma <strong>realocação</strong> ou{' '}
          <strong>indicação</strong> de emergência.{' '}
          <span role="img" aria-label="handshake">
            🤝
          </span>
        </p>
        <Form ref={formRef} onSubmit={handleSession}>
          <h1>Faça seu login</h1>
          <InputWrapper
            autoFocus
            name="id"
            placeholder="Sua ID"
            value={id}
            onChange={e => setId(e.target.value)}
          />
          <Button>{loading ? 'Carregando...' : 'Entrar'}</Button>
          <RegisterLink to="/register">
            <FiLogIn size={16} color={colors.danger} />
            Não tenho cadastro
          </RegisterLink>
        </Form>
      </FormWrapper>

      <GiveahandImg />
    </Container>
  );
}
